module.exports = __webpack_public_path__ + "assets/pricing.9f233528.svg";